// extracted by mini-css-extract-plugin
export default {"checkbox-input":"style_checkbox-input__ai2QH","checkbox-label":"style_checkbox-label__EEI++","checkbox-icon":"style_checkbox-icon__LNP1Y"};